/// <amd-module name="Repos/Changes/Components/ChangeSummaryImageContent" />
import * as React from "react";
import { useChangesContext } from "Repos/ChangesCommon/ChangesContext";
import { DiffViewerType, IFileDiff } from "Repos/ChangesCommon/Contracts";
import { IFileContentDetails, IImageDiffViewerProps, IImageViewerProps } from "Repos/Common/Contracts/Editor";
import { WrappedComponent } from "VSS/Platform/Layout";

export interface IChangeSummaryImageContentProps {
    fileDiff: IFileDiff;
}

export function ChangeSummaryImageContent<TVersionDescriptor>(props: IChangeSummaryImageContentProps): JSX.Element {
    const { fileDiff } = props;
    const { filesService } = useChangesContext<TVersionDescriptor>();

    let modifiedUrl: string | undefined;
    let modifiedContent: IFileContentDetails | undefined;

    if (fileDiff.modifiedFile) {
        modifiedUrl = filesService.getFileDownloadUrl(
            fileDiff.modifiedFile.serverItem,
            filesService.convertVersionToDescriptor(fileDiff.modifiedFile.version)
        );

        modifiedContent = {
            content: "",
            contentTruncated: false,
            objectId: "",
            resourceUri: "",
            metadata: {
                contentType: "",
                encoding: 0,
                extension: "",
                fileName: fileDiff.modifiedFile.serverItem,
                isBinary: false,
                isImage: true,
                vsLink: ""
            }
        };
    }

    let originalUrl: string | undefined;
    let originalContent: IFileContentDetails | undefined;
    if (fileDiff.originalFile) {
        originalUrl = filesService.getFileDownloadUrl(
            fileDiff.originalFile.serverItem,
            filesService.convertVersionToDescriptor(fileDiff.originalFile.version)
        );

        originalContent = {
            content: "",
            contentTruncated: false,
            objectId: "",
            resourceUri: "",
            metadata: {
                contentType: "",
                encoding: 0,
                extension: "",
                fileName: fileDiff.originalFile.serverItem,
                isBinary: false,
                isImage: true,
                vsLink: ""
            }
        };
    }

    return (
        <div className={"flex-row scroll-hidden"}>
            {originalUrl && modifiedUrl ? (
                <WrappedComponent<IImageDiffViewerProps>
                    wrappedType="repos-image-diff-viewer"
                    dependencies={["ms.vss-code-web.code-editor"]}
                    wrappedProps={{
                        isPixelDiff: false, // Not supported in summary
                        diffOrientation: filesService.getDiffOrientation(DiffViewerType.summary),
                        modifiedContentUrl: modifiedUrl,
                        modifiedContent: modifiedContent!,
                        originalContentUrl: originalUrl,
                        originalContent: originalContent!
                    }}
                />
            ) : (
                <WrappedComponent<IImageViewerProps>
                    wrappedType="repos-image-viewer"
                    dependencies={["ms.vss-code-web.code-editor"]}
                    wrappedProps={{
                        url: modifiedUrl || originalUrl!,
                        content: modifiedContent || originalContent!
                    }}
                />
            )}
        </div>
    );
}
